module.exports = __webpack_public_path__ + "img/PY.9f48a110.svg";